import React from 'react';
import UDFormLabel from 'ud-form/components/label';

const SkeletonBlock = ({ height, className }: { height: number; className?: string }) => (
  <div className={className}>
    <div style={{ height, width: '100%' }} className="skeleton-block" />
  </div>
);

const NotificationFormSkeleton: React.FC = () => (
  <div className="d-flex flex-column col-6 gap-4">
    <div>
      <UDFormLabel className="mb-2">Тип уведомления</UDFormLabel>
      <SkeletonBlock height={38} />
    </div>
    <div>
      <UDFormLabel className="mb-2">Заголовок</UDFormLabel>
      <SkeletonBlock height={38} />
    </div>
    <div>
      <UDFormLabel className="mb-2">Текст</UDFormLabel>
      <SkeletonBlock height={120} />
    </div>
    <div className="d-flex justify-content-start mt-4 gap-3">
      <SkeletonBlock height={38} className="w-100" />
      <SkeletonBlock height={38} className="w-100" />
    </div>
  </div>
);

export default NotificationFormSkeleton;
